/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ShareTypeEditRequest { 
    id?: number;
    name: string;
    perShareValue: number;
    accountName?: string | null;
    accountCode?: string | null;
    accountLedgerName?: string | null;
    ledgerType?: string | null;
    allowedAsGuarantor?: boolean;
    allowedAsCollateral?: boolean;
}

